'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../identifiers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Box = function (_React$Component) {
  _inherits(Box, _React$Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          theme = _props.theme,
          bgColor = _props.bgColor,
          bgImage = _props.bgImage,
          caption = _props.caption,
          hasShadow = _props.hasShadow,
          transparent = _props.transparent,
          footer = _props.footer,
          centered = _props.centered,
          bordered = _props.bordered,
          opaque = _props.opaque,
          clickable = _props.clickable,
          unclickable = _props.unclickable,
          children = _props.children,
          width = _props.width,
          height = _props.height,
          borderRadius = _props.borderRadius,
          centerContent = _props.centerContent,
          hoverEffect = _props.hoverEffect,
          wrapperClassName = _props.wrapperClassName,
          boxClassName = _props.boxClassName,
          other = _objectWithoutProperties(_props, ['theme', 'bgColor', 'bgImage', 'caption', 'hasShadow', 'transparent', 'footer', 'centered', 'bordered', 'opaque', 'clickable', 'unclickable', 'children', 'width', 'height', 'borderRadius', 'centerContent', 'hoverEffect', 'wrapperClassName', 'boxClassName']);

      var boxClass = (0, _classnames2['default'])(theme.box, boxClassName, (_classNames = {}, _defineProperty(_classNames, theme.shadow, hasShadow), _defineProperty(_classNames, theme.transparent, transparent), _defineProperty(_classNames, theme.centered, centered), _defineProperty(_classNames, theme.bordered, bordered), _defineProperty(_classNames, theme.opaque, opaque), _defineProperty(_classNames, theme.clickable, clickable), _defineProperty(_classNames, theme.unclickable, unclickable), _defineProperty(_classNames, theme.centerContent, centerContent), _classNames));
      var wrapperClass = (0, _classnames2['default'])(theme.wrapper, wrapperClassName, _defineProperty({}, theme.hoverScale, hoverEffect === 'scale'));
      var captionClassName = (0, _classnames2['default'])(theme.caption, _defineProperty({}, theme.centered, centered));
      var footerClassName = (0, _classnames2['default'])(theme.footer, _defineProperty({}, theme.centered, centered));
      var captionContainer = caption.length ? _react2['default'].createElement('div', {
        className: captionClassName
      }, caption) : null;
      var footerContainer = footer ? _react2['default'].createElement('div', {
        className: footerClassName
      }, footer) : null; // Inline Styles

      var boxStyle = {};

      if (bgColor) {
        boxStyle.backgroundColor = bgColor;
      }

      if (bgImage) {
        boxStyle.backgroundImage = 'url(' + bgImage + ')';
      }

      if (width) {
        boxStyle.width = width;
      }

      if (height) {
        boxStyle.height = height;
      }

      if (borderRadius) {
        boxStyle.borderRadius = borderRadius;
      }

      return _react2['default'].createElement('div', _extends({
        className: wrapperClass
      }, other), captionContainer, _react2['default'].createElement('div', {
        className: boxClass,
        style: boxStyle
      }, children), footerContainer);
    }
  }]);

  return Box;
}(_react2['default'].Component);

Box.themeShape = {
  wrapper: _propTypes2['default'].string.isRequired,
  box: _propTypes2['default'].string.isRequired,
  caption: _propTypes2['default'].string.isRequired,
  shadow: _propTypes2['default'].string.isRequired,
  centered: _propTypes2['default'].string.isRequired,
  centerContent: _propTypes2['default'].string.isRequired,
  clickable: _propTypes2['default'].string.isRequired,
  hoverScale: _propTypes2['default'].string.isRequired
};
Box.propTypes = {
  children: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].node), _propTypes2['default'].node]),
  theme: _propTypes2['default'].shape(Box.themeShape).isRequired,
  footer: _propTypes2['default'].node,
  hasShadow: _propTypes2['default'].bool,
  transparent: _propTypes2['default'].bool,
  centered: _propTypes2['default'].bool,
  bordered: _propTypes2['default'].bool,
  opaque: _propTypes2['default'].bool,
  clickable: _propTypes2['default'].bool,
  unclickable: _propTypes2['default'].bool,
  centerContent: _propTypes2['default'].bool,
  caption: _propTypes2['default'].string,
  bgColor: _propTypes2['default'].string,
  bgImage: _propTypes2['default'].string,
  width: _propTypes2['default'].string,
  height: _propTypes2['default'].string,
  borderRadius: _propTypes2['default'].string,
  wrapperClassName: _propTypes2['default'].string,
  boxClassName: _propTypes2['default'].string,
  handleClickOutside: _propTypes2['default'].func,
  hoverEffect: _propTypes2['default'].oneOf(['scale'])
};
Box.defaultProps = {
  hasShadow: false,
  transparent: false,
  caption: '',
  footer: null
};
exports['default'] = (0, _reactCssThemr.themr)(_identifiers.BOX)(Box);
exports.Box = Box;